import type { UserAccount } from "@src/yellowstone/modules/users";

export const calculateTotalBalance = (accounts: UserAccount[]): number => {
  return accounts.reduce((prev, curr) => prev + (curr.balance ?? 0), 0);
};
